"use client";

import DiscussionsBox from "components/company/v3/boxes/DiscussionsBox";
import useBrazilianRealEstateFundIssuer from "components/company/v3/context/hooks/useBrazilianRealEstateFundIssuer";
import type { CompanyDiscussionsTabEnum } from "components/company/v3/menu/enums";
import { IAssetType, ISecurityCountry } from "types/graphqlTypes";

interface FiisDiscussionsBoxProps {
  tickerSymbol: string;
  tab: CompanyDiscussionsTabEnum;
  onChangeTab: (tab: CompanyDiscussionsTabEnum) => void;
}

export default function FiisDiscussionsBox({ tickerSymbol, tab, onChangeTab }: FiisDiscussionsBoxProps) {
  const issuer = useBrazilianRealEstateFundIssuer();

  return (
    <DiscussionsBox
      tickerSymbol={tickerSymbol}
      issuerId={issuer._id}
      country={ISecurityCountry.Br}
      assetType={IAssetType.BrazilianRealEstateFund}
      tab={tab}
      onChangeTab={onChangeTab}
    />
  );
}
